import { apiFetch } from '@/lib/api';

export interface PlanPricing {
  price_amount: number;
  stripe_price_id: string;
}

export interface PlanTier {
  monthly: PlanPricing;
  quarterly: PlanPricing;
}

export interface PlansResponse {
  currency: 'BRL' | 'EUR';
  plans: { pro: PlanTier; business: PlanTier };
  trial: { days: number; message_cap: number };
}

export interface CheckoutSessionResponse {
  url: string;
}

export interface CustomerPortalResponse {
  url: string;
}

export type BillingTier = 'pro' | 'business';
export type BillingInterval = 'monthly' | 'quarterly';

export interface UsageResponse {
  mode: 'trial' | 'active' | 'blocked';
  used: number;
  cap: number | null;
  period_start: string | null;
  period_end: string | null;
  tier: string | null;
  status: string;
}

export interface Invoice {
  id: string;
  number: string | null;
  status: string | null;
  /** Amount in minor units (e.g. cents) */
  amount: number;
  /** ISO currency code, e.g. 'eur', 'brl' */
  currency: string;
  /** Unix timestamp (seconds) */
  created: number;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
}

export const billingService = {
  getPlans(): Promise<PlansResponse> {
    return apiFetch<PlansResponse>('/onboarding/plans');
  },
  createCheckoutSession(args: {
    tier: BillingTier;
    interval: BillingInterval;
  }): Promise<CheckoutSessionResponse> {
    return apiFetch<CheckoutSessionResponse>('/onboarding/stripe/checkout', {
      method: 'POST',
      body: JSON.stringify(args),
    });
  },
  getCustomerPortalUrl(): Promise<CustomerPortalResponse> {
    return apiFetch<CustomerPortalResponse>('/billing/customer-portal', {
      method: 'POST',
    });
  },
  getUsage(): Promise<UsageResponse> {
    return apiFetch<UsageResponse>('/billing/usage');
  },
  listInvoices(): Promise<Invoice[]> {
    return apiFetch<{ invoices: Invoice[] }>('/billing/invoices').then((r) => r.invoices);
  },
};
